import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../AuthContext'
import { API_BASE } from '../config'

const C = {
  g700:'#235233', g500:'#3D8A57', g50:'#F2FAF5', border:'#C8DDD2', text:'#1A2820', muted:'#5A7065',
  grad:'linear-gradient(150deg,#0F3D24 0%,#1E6B3C 60%,#2E8B4F 100%)',
}

// Native "Revive Doctor" app: phone → WhatsApp OTP login, gated to approved doctors.
export default function DoctorLoginGate() {
  const { user, login } = useAuth()
  const navigate = useNavigate()
  const [mode, setMode] = React.useState('otp')      // 'otp' | 'password'
  const [step, setStep] = React.useState('phone')   // 'phone' | 'otp'
  const [phone, setPhone] = React.useState('')
  const [otp, setOtp] = React.useState('')
  const [devOtp, setDevOtp] = React.useState('')
  const [email, setEmail] = React.useState('')
  const [password, setPassword] = React.useState('')
  const [loading, setLoading] = React.useState(false)
  const [error, setError] = React.useState('')

  if (user?.token) return null

  const passwordLogin = async (e) => {
    e && e.preventDefault()
    const em = email.trim().toLowerCase()
    if (!em || !password) { setError('Enter your email and password.'); return }
    setLoading(true); setError('')
    try {
      const res = await fetch(`${API_BASE}/api/doctor/password-login`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: em, password }),
      })
      const data = await res.json()
      if (!res.ok || !data.token) throw new Error(data.message || 'Invalid email or password')
      login('doctor', data.user?.name || 'Doctor', data.user?.email, data.token, data.refreshToken)
      navigate('/', { replace: true })
    } catch (err) { setError(err.message) }
    finally { setLoading(false) }
  }

  const sendOtp = async (e) => {
    e && e.preventDefault()
    const p = phone.trim()
    if (p.replace(/\D/g, '').length < 10) { setError('Enter a valid mobile number.'); return }
    setLoading(true); setError(''); setDevOtp('')
    try {
      const res = await fetch(`${API_BASE}/api/otp/send`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ phone: p, role: 'doctor' }),
      })
      const data = await res.json()
      if (!res.ok) throw new Error(data.message || 'Could not send code')
      if (data.otp) setDevOtp(data.otp)   // WhatsApp not configured → server returns code for testing
      setStep('otp')
    } catch (err) { setError(err.message) }
    finally { setLoading(false) }
  }

  const verifyOtp = async (e) => {
    e && e.preventDefault()
    const code = otp.trim()
    if (code.length < 4) { setError('Enter the code sent to your phone.'); return }
    setLoading(true); setError('')
    try {
      const res = await fetch(`${API_BASE}/api/otp/verify`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ phone: phone.trim(), otp: code, role: 'doctor' }),
      })
      const data = await res.json()
      if (!res.ok || !data.token) throw new Error(data.message || 'Invalid code')
      login('doctor', data.user?.name || 'Doctor', data.user?.email, data.token, data.refreshToken)
      navigate('/', { replace: true })
    } catch (err) { setError(err.message) }
    finally { setLoading(false) }
  }

  const field = { padding:'.85rem 1rem', border:`1.5px solid ${C.border}`, borderRadius:11, fontSize:'.95rem', outline:'none', fontFamily:'inherit', color:C.text, boxSizing:'border-box', width:'100%' }
  const btn = { padding:'.95rem', borderRadius:11, background: loading ? C.g500 : C.g700, color:'#fff', border:'none', fontSize:'.95rem', fontWeight:700, cursor:'pointer', fontFamily:'inherit', marginTop:'.25rem' }

  return (
    <div style={{ position:'fixed', inset:0, zIndex:2000, background:'#fff', overflowY:'auto', fontFamily:"'DM Sans',sans-serif", display:'flex', flexDirection:'column' }}>
      <div style={{ background:C.grad, padding:'3.5rem 1.5rem 2.5rem', color:'#fff' }}>
        <div style={{ fontSize:'.7rem', letterSpacing:'.18em', textTransform:'uppercase', opacity:.7, marginBottom:'.6rem' }}>Revive · Doctor</div>
        <div style={{ fontFamily:"'DM Serif Display',serif", fontSize:'1.7rem' }}>Doctor sign in 🩺</div>
        <div style={{ fontSize:'.85rem', opacity:.7, marginTop:'.35rem' }}>
          {mode === 'password' ? 'Sign in with your email and password.' : (step === 'phone' ? 'We’ll send a code to your registered number.' : `Enter the code sent to ${phone}.`)}
        </div>
      </div>

      <div style={{ padding:'1.75rem 1.5rem', display:'flex', flexDirection:'column', gap:'1rem', maxWidth:440, width:'100%', margin:'0 auto', boxSizing:'border-box' }}>
        {mode === 'password' ? (
          <form onSubmit={passwordLogin} style={{ display:'flex', flexDirection:'column', gap:'1rem' }}>
            <label style={{ fontSize:'.7rem', fontWeight:600, color:C.muted, textTransform:'uppercase', letterSpacing:'.06em' }}>Email</label>
            <input type="email" autoComplete="username" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@clinic.com" style={field} />
            <label style={{ fontSize:'.7rem', fontWeight:600, color:C.muted, textTransform:'uppercase', letterSpacing:'.06em' }}>Password</label>
            <input type="password" autoComplete="current-password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Your password" style={field} />
            {error && <div style={{ fontSize:'.8rem', color:'#C0392B', background:'#FFF0F0', border:'1px solid #FFC9C9', borderRadius:9, padding:'.6rem .8rem' }}>{error}</div>}
            <button type="submit" disabled={loading} style={btn}>{loading ? 'Signing in…' : 'Sign in →'}</button>
            <button type="button" onClick={() => { setMode('otp'); setError('') }}
              style={{ background:'none', border:'none', color:C.muted, fontSize:'.8rem', cursor:'pointer', fontFamily:'inherit' }}>← Use phone OTP instead</button>
          </form>
        ) : step === 'phone' ? (
          <form onSubmit={sendOtp} style={{ display:'flex', flexDirection:'column', gap:'1rem' }}>
            <label style={{ fontSize:'.7rem', fontWeight:600, color:C.muted, textTransform:'uppercase', letterSpacing:'.06em' }}>Mobile number</label>
            <input type="tel" inputMode="numeric" value={phone} onChange={e => setPhone(e.target.value)} placeholder="9XXXXXXXXX" style={field} />
            {error && <div style={{ fontSize:'.8rem', color:'#C0392B', background:'#FFF0F0', border:'1px solid #FFC9C9', borderRadius:9, padding:'.6rem .8rem' }}>{error}</div>}
            <button type="submit" disabled={loading} style={btn}>{loading ? 'Sending…' : 'Send code →'}</button>
            <button type="button" onClick={() => { setMode('password'); setError('') }}
              style={{ background:'none', border:'none', color:C.muted, fontSize:'.8rem', cursor:'pointer', fontFamily:'inherit' }}>Sign in with email &amp; password instead</button>
          </form>
        ) : (
          <form onSubmit={verifyOtp} style={{ display:'flex', flexDirection:'column', gap:'1rem' }}>
            <label style={{ fontSize:'.7rem', fontWeight:600, color:C.muted, textTransform:'uppercase', letterSpacing:'.06em' }}>Verification code</label>
            <input type="tel" inputMode="numeric" value={otp} onChange={e => setOtp(e.target.value)} placeholder="6-digit code" style={{ ...field, letterSpacing:'.3em', textAlign:'center', fontSize:'1.2rem' }} />
            {devOtp && <div style={{ fontSize:'.78rem', color:C.muted, background:C.g50, borderRadius:9, padding:'.55rem .8rem' }}>Dev code: <strong>{devOtp}</strong></div>}
            {error && <div style={{ fontSize:'.8rem', color:'#C0392B', background:'#FFF0F0', border:'1px solid #FFC9C9', borderRadius:9, padding:'.6rem .8rem' }}>{error}</div>}
            <button type="submit" disabled={loading} style={btn}>{loading ? 'Verifying…' : 'Verify & sign in →'}</button>
            <button type="button" onClick={() => { setStep('phone'); setOtp(''); setError('') }}
              style={{ background:'none', border:'none', color:C.muted, fontSize:'.8rem', cursor:'pointer', fontFamily:'inherit' }}>← Change number</button>
          </form>
        )}
        <div style={{ fontSize:'.75rem', color:C.muted, textAlign:'center', marginTop:'.5rem', lineHeight:1.6 }}>
          Only approved doctors can sign in. Ask your clinic admin if your number isn’t recognised.
        </div>
      </div>
    </div>
  )
}
